// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".userIconPlaceholder[data-v-30e73830]{-webkit-filter:invert(1);filter:invert(1)}.short-profile-box-inner img[data-v-30e73830]{vertical-align:middle}.short-profile-box-inner[data-v-30e73830] h4{font-weight:500}.details h5[data-v-30e73830],.details p[data-v-30e73830]{vertical-align:middle;text-align:center}", ""]);
// Exports
module.exports = exports;
